import { Card, CardContent } from "@tabipla/ui";
import { usePackingContext } from "./PackingContext";
import { PackingProgress } from "./PackingProgress";
import { AddPackingItemForm } from "./AddPackingItemForm";
import { PackingItemsList } from "./PackingItemsList";
import { EmptyPackingList } from "./EmptyPackingList";
import { AiSuggestionsDialog } from "./AiSuggestionsDialog";
import { TemplateSelectionDialog } from "./TemplateSelectionDialog";
import { BulkEditActionBar } from "./BulkEditActionBar";

/**
 * PackingList presenter component.
 * All sub-components get their data from PackingContext.
 * This component orchestrates which sub-components to render.
 */
export function PackingList() {
  const { items, progress, isLoading, isEditMode } = usePackingContext();

  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-center py-8">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {/* Progress Header */}
      {progress && progress.total > 0 && <PackingProgress />}

      {/* Add Item Form */}
      <AddPackingItemForm />

      {/* Items List or Empty State */}
      {items.length === 0 ? <EmptyPackingList /> : <PackingItemsList />}

      {/* AI Suggestions Dialog */}
      <AiSuggestionsDialog />

      {/* Template Selection Dialog */}
      <TemplateSelectionDialog />

      {/* Bulk Edit Action Bar */}
      {isEditMode && <BulkEditActionBar />}
    </div>
  );
}
